<div class="container-fluid mb-5" *ngIf="user$ | async as user">
  <div class="row">
    <div class="col">Dr. {{ user.displayName }}</div>
    <div class="col-2">
      <div class="d-flex">
        <div class="mr-2">Fisa numarul</div>
        <span class="fill-underline"></span>
      </div>
    </div>
    <div class="col-auto">din data de {{ date }} ora {{ hour }}</div>
  </div>
  <div class="row">
    <div class="col">Str. Dezrobirii 43 Bucuresti Sector 6</div>
    <div class="col-auto">Email: {{ user.email }}</div>
  </div>
  <div class="row">
    <div class="col-auto">Telefon: +40.762.668.289</div>
  </div>
</div>

<ng-container *ngIf="patient$ | async as patient">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <h1 class="text-center">{{ (cabinet$ | async)?.name | uppercase }} Fisa nr.</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h2 class="text-center">Proprietar: {{ patient?.ownerName }}</h2>
      </div>
    </div>
  </div>

  <div class="container-fluid table-container mb-5">
    <div class="row">
      <div class="col-8">
        <strong>Adresa:</strong>
      </div>
      <div class="col-2">
        <div class="d-flex flex-column">
          <span><strong>Telefon:</strong> {{ patient?.ownerPhoneNumber }}</span>
          <span><strong>Email:</strong> {{ patient?.ownerEmail }}</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <strong>Specie:</strong> {{ patient?.species }}
      </div>
      <div class="col">
        <strong>Rasa:</strong> {{ patient?.breed }}
      </div>
    </div>
    <div class="row">
      <div class="col">
        <strong>Varsta:</strong> {{ getAgeFromBirthDate(patient?.birthDate) }}
      </div>
      <div class="col">
        <strong>Sex:</strong> {{ patient?.gender === 'F' ? 'Feminin' : 'Masculin' }}
      </div>
      <div class="col">
        <strong>Nume:</strong> {{ patient?.name }}
      </div>
      <div class="col">
        <strong>Nr. Microcip:</strong>
      </div>
    </div>
  </div>
</ng-container>

<div class="container-fluid">
  <div class="row">
    <div class="col">
      <h3>Plan de tratament</h3>
    </div>
  </div>
</div>
<div class="table-container container-full-height" *ngIf="records$ | async as records">
  <div class="container-fluid">
    <div class="row table-header">
      <div class="col">
        <strong>Data</strong>
      </div>
      <div class="col-3">
        <strong>Anamneza - semne clinice</strong>
      </div>
      <div class="col-3">
        <strong>Investigatii - diagnostic</strong>
      </div>
      <div class="col-3">
        <strong>Tratament - recomandari</strong>
      </div>
      <div class="col">
        <strong>Medic</strong>
      </div>
    </div>
    <div class="row" *ngFor="let record of records">
      <div class="col">
        {{ getFormattedCreatedAt(record?.createdAt) }}
      </div>
      <div class="col-3">
        {{ record?.anamnesis?.value }}
      </div>
      <div class="col-3">
        {{ record?.investigations?.value }}
      </div>
      <div class="col-3">
        {{ record?.treatment?.value }}
      </div>
      <div class="col">
        {{ record?.createdBy?.userName }}
      </div>
    </div>
  </div>
  <div class="container-fluid container-fill">
    <div class="row row-fill">
      <div class="col"></div>
      <div class="col-3"></div>
      <div class="col-3"></div>
      <div class="col-3"></div>
      <div class="col"></div>
    </div>
  </div>
  <!-- <table>
    <thead>
      <tr>
        <th>Data</th>
        <th>Anamneza - semne clinice</th>
        <th>Investigatii - diagnostic</th>
        <th>Tratament - recomandari</th>
        <th>Medic</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let record of records">
        <td>
          <span>
            {{ getFormattedCreatedAt(record?.createdAt) }}
          </span>
        </td>
        <td>{{ record?.anamnesis?.value }}</td>
        <td>{{ record?.investigations?.value }}</td>
        <td>{{ record?.treatment?.value }}</td>
        <td>{{ record?.createdBy?.userName }}</td>
      </tr>
    </tbody>
  </table> -->
</div>

<!-- <pre>{{ records$ | async | json }}</pre>
<pre>{{ today | json }}</pre>
<pre>{{ account$ | async | json }}</pre>
<pre>{{ cabinet$ | async | json }}</pre>
<pre>{{ patient$ | async | json }}</pre> -->